/*
 *   File : connect-broker.js
 *   Author : https://evoqins.com
 *   Description : Connect broker modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

// Assets 
import ConnectBroker from "../../Assets/Images/Modal/connect-broker-img.webp";
import ConnectBrokerSuccess from "../../Assets/Images/Modal/broker-connect-successful.webp";

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const ConnectBrokerModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("connect-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        var button = document.getElementById("connect-modal-close");
        button.click();
        props.handleSuccess();
    };

    return (
        <div className="modal fade"
            id="connect-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="connectModalLabel"
            aria-hidden="true">




            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5`}>
                <span id='connect-modal-close' className='d-none' data-bs-dismiss="modal"></span>


                <div className="modal-content border-radius-16 overflow-hidden border-0 mx-lg-5" >
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>



                    {/* Modal body */}
                    <div className='modal-body py-0 px-3 text-center'>
                        <img src={props.type === 2 ? ConnectBrokerSuccess : ConnectBroker}
                            draggable={false}
                            width={200}
                            alt='broker' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>

                            {
                                props.type === 3 ? "Set Default Broker" : props.type === 2 ? "Broker Successfully Connected" : "Connect with Broker"
                            }
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            {
                                props.type === 3 ?
                                    `Are you sure you want to make ${props.selected_broker_name} your default broker? This action will replace your current default broker.`
                                    : props.type === 2 ?
                                        "You can now start investing seamlessly through your linked broker account. Happy investing!"
                                        : "Please connect with your broker account to proceed with investing in curated baskets."
                            }

                        </p>
                    </div>

                    {/* Modal footer */}
                    {
                        props.type == 3 ?
                            <div className='modal-footer border-0 padding-40px-lr padding-20px-tb d-block'>
                                <div className="d-flex flex-column flex-sm-row gap-2 gap-sm-3">
                                    <SecondaryButton name="Cancel"
                                        className="w-100 flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res"
                                        padding="padding-18px-tb e-padding-8px-all-res"
                                        onPress={_handleCloseModal} />
                                    <PrimaryButton name="Confirm"
                                        className="w-100 flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res"
                                        padding="padding-18px-tb e-padding-8px-all-res"
                                        onPress={_handleSuccess} />
                                </div>
                            </div>
                            :
                            <div className='modal-footer border-0 padding-40px-lr padding-20px-tb d-block'>
                                <PrimaryButton name={props.type === 2 ? "Start Investing" : "Connect with Stock Brokers"}
                                    className="w-100"
                                    onPress={_handleSuccess} />
                            </div>
                    }
                </div>
            </div>

        </div>
    )
}

ConnectBrokerModal.defaultProps = {
    handleClose: () => { },
    className: null,
};

export default memo(ConnectBrokerModal);
